import React, { useEffect, useRef } from 'react';
import { Popper, Paper, List, ListItemButton, ListItemText, Typography, Box, Divider, ClickAwayListener } from '@mui/material';

export interface SearchItem {
  id: string;
  primary: string;
  secondary?: string;
  onSelect: () => void;
}

interface GlobalSearchOverlayProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  title?: string;
  items: SearchItem[];
  emptyText?: string;
  selectedIndex?: number;
  onHoverItem?: (index: number) => void;
  onClose?: () => void;
}

const GlobalSearchOverlay: React.FC<GlobalSearchOverlayProps> = ({ anchorEl, open, title, items, emptyText, selectedIndex = -1, onHoverItem, onClose }) => {
  const width = anchorEl ? anchorEl.getBoundingClientRect().width : undefined;
  const listRef = useRef<HTMLUListElement | null>(null);

  useEffect(() => {
    if (!listRef.current || selectedIndex < 0) return;
    const node = listRef.current.querySelector(`[data-idx="${selectedIndex}"]`);
    if (node && 'scrollIntoView' in node) {
      (node as HTMLElement).scrollIntoView({ block: 'nearest' });
    }
  }, [selectedIndex]);
  return (
    <Popper open={open} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: 1300 }}>
      <ClickAwayListener onClickAway={() => onClose && onClose()}>
        <Paper elevation={3} sx={{ mt: 1, borderRadius: 2, overflow: 'hidden', border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', width }}>
          {title && (
            <Box sx={{ px: 2, py: 1 }}>
              <Typography variant="caption" color="text.secondary">{title}</Typography>
            </Box>
          )}
          <Divider />
          <List dense disablePadding ref={listRef}>
            {items.length === 0 && (
              <Box sx={{ px: 2, py: 2 }}>
                <Typography variant="body2" color="text.secondary">{emptyText || 'Brak wyników'}</Typography>
              </Box>
            )}
            {items.map((it, idx) => (
              <ListItemButton key={it.id} data-idx={idx} onClick={it.onSelect} sx={{ px: 2 }} selected={idx === selectedIndex} onMouseEnter={() => onHoverItem && onHoverItem(idx)}>
                <ListItemText primary={it.primary} secondary={it.secondary} />
              </ListItemButton>
            ))}
          </List>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default GlobalSearchOverlay;


